var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgAreaMurada = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 32 32",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M25,22 L21,22 L21,26 L29,26 L29,22 L25,22 Z M26,21 L29,21 C29.5522847,21 30,21.4477153 30,22 L30,26 C30,26.5522847 29.5522847,27 29,27 L21,27 C20.8178564,27 20.6470867,26.9513029 20.5,26.8662178 C20.3529133,26.9513029 20.1821436,27 20,27 L12,27 C11.8178564,27 11.6470867,26.9513029 11.5,26.8662178 C11.3529133,26.9513029 11.1821436,27 11,27 L3,27 C2.44771525,27 2,26.5522847 2,26 L2,22 C2,21.4477153 2.44771525,21 3,21 L7,21 L7,17 L3,17 C2.44771525,17 2,16.5522847 2,16 L2,12 C2,11.4477153 2.44771525,11 3,11 L7,11 L7,7 C7,6.44771525 7.44771525,6 8,6 L16,6 C16.1821436,6 16.3529133,6.04869714 16.5,6.1337822 C16.6470867,6.04869714 16.8178564,6 17,6 L25,6 C25.5522847,6 26,6.44771525 26,7 L26,11 L29,11 C29.5522847,11 30,11.4477153 30,12 L30,16 C30,16.5522847 29.5522847,17 29,17 L26,17 L26,21 Z M20,26 L20,22 L17,22 L16,22 L12,22 L12,26 L20,26 Z M25,21 L25,17 L21,17 L20,17 L17,17 L17,21 L20,21 L21,21 L25,21 Z M11,22 L8,22 L3,22 L3,26 L11,26 L11,22 Z M16,21 L16,17 L12,17 L11,17 L8,17 L8,21 L11,21 L12,21 L16,21 Z M17,16 L20,16 L20,12 L17,12 L16,12 L12,12 L12,16 L16,16 L17,16 Z M21,16 L25,16 L29,16 L29,12 L25,12 L21,12 L21,16 Z M8,16 L11,16 L11,12 L8,12 L3,12 L3,16 L8,16 Z M25,11 L25,7 L17,7 L17,11 L20,11 L21,11 L25,11 Z M16,11 L16,7 L8,7 L8,11 L11,11 L12,11 L16,11 Z"
  }));
};
export default SvgAreaMurada;